import { BASE_URL } from "../BaseUrl.js"; 
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("momo4scoohclient")
  if (token) {
    config.headers.Authorization =  `Bearer `;
  } else {
    config.headers.Authorization =  null;
  }

  const codeEntite = localStorage.getItem("entiteSchoolCode")
  if (codeEntite) {
    config.headers['ref_entity'] = `client_${codeEntite}`;
  } else {
    config.headers['ref_entity'] =  null;
  }

  return config;
});

export const getInformationEntite = async (url) => {
  return await axios.get(
    BASE_URL(`rechercherinforentiteparroot?root=${url}`),
    {}
  );
};

export const getListeEntite = async (page, size) => {
  return await axios.get(
    BASE_URL(`listeentites?page=${page}&size=${size}`),
    {}
  );
};

export const getListeSousEntite = async (page, size) => {
  return await axios.get(
    BASE_URL(`etablissement/rechercheretablissementparutilisateur`),
    {}
  );
};

export const ajoutEntite = async (values) => {
  return await axios.post(
    BASE_URL("enregistrerentite"),
    values
  );
};

export const deleteEntite = async (serviceId) => {
  return await axios.delete(
    BASE_URL(`admin/supprimerentite/${serviceId}`),
    {}
  );
};